import { Placeholder } from './Placeholder';

export const NextUpBox = () => <Placeholder className="min-h-[100px]">Next Up Box</Placeholder>;
